module.exports = __webpack_public_path__ + "static/ourMissionBack-96394c90ae96e4baf6bbcbfc49f8ed6d.png";